export default __webpack_public_path__ + "static/media/Hair_7_M_C3.2272f2d7.svg";